import { adminHttpClient } from '../../../commons/adminHttpClient'
import { BaseProductClassValues } from './productClass/baseProductClass'

interface ExpenseReimbursementValues extends BaseProductClassValues {
  eobRequired: boolean
  requiresPrescription: boolean
  expenseCategories: number[]
  productClassId: string
}

const updateExpenseReimbursement = (values: ExpenseReimbursementValues): Promise<any> => {
  return adminHttpClient.put('/AdminDashboard/ClassDesign/ExpenseReimbursement', values)
}

export default updateExpenseReimbursement
